(function () {
  const charts = new Map();
  const chartFontFamily = "IBM Plex Sans, Arial, sans-serif";
  const minChartFontSize = 13;
  const getChartFontSize = (baseSize, multiplier = 1) =>
    Math.max(minChartFontSize, baseSize * multiplier);

  const parseChartValues = (raw) => {
    if (!raw) return { labels: [], values: [] };
    const labels = [];
    const values = [];
    raw.split(",").forEach((part) => {
      const idx = part.indexOf(":");
      if (idx === -1) return;
      const label = part.slice(0, idx).trim();
      const value = Number(part.slice(idx + 1).trim());
      if (!label || Number.isNaN(value)) return;
      labels.push(label);
      values.push(value);
    });
    return { labels, values };
  };

  const drawBackgroundRadar = (context, chart, backgroundURL, chartCupper) => {
    const alpha = 28;
    let bTop = chart.chartArea.top;
    const tHeight = chart.chartArea.bottom - chart.chartArea.top - alpha;
    const bHeight = tHeight * (800 / 667);
    const bWidth = bHeight;

    bTop = bTop - Math.abs(bHeight - tHeight) / 2 + alpha / 2;
    const bLeft = (chart.width - bWidth) / 2;
    const baseImage = new Image();
    baseImage.src = backgroundURL;

    baseImage.onload = function () {
      context.drawImage(baseImage, bLeft, bTop, bWidth, bHeight);

      if (chartCupper) {
        const fSize = chart.width / 50;
        context.font =
          "normal " + getChartFontSize(fSize, 1.3) + "px " + chartFontFamily;
        context.fillStyle = "black";
        context.textAlign = "center";
        context.fillText(
          "Cupper's Correction " + chartCupper,
          (chart.chartArea.right - chart.chartArea.left) / 2,
          chart.chartArea.bottom + fSize / 2 + 10
        );
      }
    };
  };

  const drawBackgroundPolar = (context, chart, backgroundURL) => {
    let bTop = chart.chartArea.top;
    const tHeight = chart.chartArea.bottom - chart.chartArea.top;
    const bHeight = tHeight * (800 / 667);
    const bWidth = bHeight;

    bTop = bTop - Math.abs(bHeight - tHeight) / 2;
    const bLeft = (chart.width - bWidth) / 2;
    const baseImage = new Image();
    baseImage.src = backgroundURL;

    baseImage.onload = function () {
      context.drawImage(baseImage, bLeft, bTop, bWidth, bHeight);
    };
  };

  const buildRadar = (ctx, config) => {
    const fSize = ctx.canvas.clientWidth / 50;
    return new Chart(ctx, {
      type: "radar",
      data: {
        labels: config.labels,
        datasets: [
          {
            label: config.chartLabel,
            data: config.values,
            backgroundColor: "rgba(200, 200, 200, 0.3)",
            borderColor: "rgba(46, 72, 195, 0.81)",
            borderWidth: 3,
            pointRadius: 0,
          },
        ],
      },
      options: {
        animation: {
          duration: 0,
          onComplete: function () {
            const context = this.chart.ctx;
            context.font = Chart.helpers.fontString(
              minChartFontSize,
              "normal",
              chartFontFamily
            );
            context.fillStyle = "black";
            context.textAlign = "center";
            context.textBaseline = "bottom";

            this.data.datasets.forEach(function (dataset) {
              for (let i = 0; i < dataset.data.length; i += 1) {
                for (const key in dataset._meta) {
                  const model = dataset._meta[key].data[i]._model;
                  context.fillText(dataset.data[i], model.x, model.y - 5);
                }
              }
            });
          },
        },
        scale: {
          display: false,
          ticks: {
            beginAtZero: true,
            min: 5,
            max: 10,
            stepSize: 1,
          },
        },
        tooltips: {
          enabled: false,
        },
        title: {
          padding: fSize * 2.1,
          lineHeight: "40px",
          text: "Score: " + config.chartScore,
          display: true,
          fontFamily: chartFontFamily,
          fontStyle: "bold",
          fontColor: "#000",
          fontSize: getChartFontSize(fSize, 2.6),
          position: "bottom",
        },
        legend: {
          display: true,
          position: "top",
          onClick: function () {},
          labels: {
            fontFamily: chartFontFamily,
            fontStyle: "bold",
            fontColor: "#000",
            fontSize: getChartFontSize(fSize, 2.2),
            boxWidth: 0,
            fillStyle: "transparent",
            strokeStyle: "transparent",
            padding: 10,
          },
        },
      },
      plugins: [
        {
          beforeDraw: function (chart) {
            const context = chart.chart.ctx;
            context.fillStyle = "white";
            context.fillRect(0, 0, chart.width, chart.height);
          },
          afterDraw: function (chart) {
            if (config.chartBackground) {
              drawBackgroundRadar(
                chart.chart.ctx,
                chart,
                config.chartBackground,
                config.chartCupper
              );
            }
          },
        },
      ],
    });
  };

  const buildPolar = (ctx, config) => {
    const fSize = ctx.canvas.clientWidth / 50;
    return new Chart(ctx, {
      type: "polarArea",
      data: {
        labels: config.labels,
        datasets: [
          {
            label: config.chartLabel,
            data: config.values,
            backgroundColor: [
              "rgba(239, 152, 152, 0.7)",
              "rgba(241, 194, 50, 0.7)",
              "rgba(246, 178, 107, 0.7)",
              "rgba(191, 144, 0, 0.7)",
              "rgba(204, 0, 0, 0.7)",
              "rgba(230, 145, 56, 0.7)",
              "rgba(53, 28, 117, 0.7)",
              "rgba(166, 28, 0, 0.7)",
              "rgba(102, 0, 0, 0.7)",
              "rgba(127, 96, 0, 0.7)",
              "rgba(106, 168, 79, 0.7)",
              "rgba(56, 118, 29, 0.7)",
              "rgba(91, 15, 0, 0.7)",
              "rgba(53, 28, 117, 0.7)",
            ],
            borderColor: "#ccc",
            borderWidth: 1,
          },
        ],
      },
      options: {
        animation: {
          duration: 0,
        },
        scale: {
          display: false,
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 5,
            stepSize: 0.5,
          },
        },
        tooltips: {
          enabled: false,
        },
        events: ["click"],
        hover: { mode: null },
        arc: {
          borderColor: "#000077",
        },
        title: {
          padding: 20,
          text: config.chartLabel,
          display: true,
          fontFamily: chartFontFamily,
          fontColor: "#000",
          fontStyle: "bold",
          fontSize: getChartFontSize(fSize, 2.2),
          position: "top",
        },
        legend: {
          display: true,
          position: "bottom",
          onClick: function (e) {
            e.stopPropagation();
          },
          labels: {
            fontFamily: chartFontFamily,
            fontStyle: "normal",
            fontColor: "rgb(155, 99, 132)",
            fontSize: getChartFontSize(fSize, 1),
            usePointStyle: true,
            boxWidth: fSize * 3,
            padding: fSize * 1.2,
          },
        },
      },
      plugins: [
        {
          beforeDraw: function (chart) {
            const context = chart.chart.ctx;
            context.fillStyle = "white";
            context.fillRect(0, 0, chart.width, chart.height);
            if (config.chartBackground) {
              drawBackgroundPolar(context, chart, config.chartBackground);
            }
          },
        },
      ],
    });
  };

  const renderOne = (el) => {
    const chartType = el.dataset.chartType || null;
    const chartId = el.dataset.chartId || null;
    const chartValue = el.dataset.chartValue || null;
    const chartBackground = el.dataset.chartBackground || null;
    const chartLabel = el.dataset.chartLabel || "Label";
    const chartScore = el.dataset.chartScore || "00";
    const chartCupper = el.dataset.cupperCorrection || null;

    if (!chartType || !chartId || !chartValue) return;
    const canvas = document.getElementById(chartId);
    if (!canvas) return;

    const isVisible = canvas.offsetParent !== null;
    if (!isVisible) return;

    if (charts.has(chartId)) {
      charts.get(chartId).destroy();
      charts.delete(chartId);
    }

    canvas.classList.remove("loading");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const parsed = parseChartValues(chartValue);
    if (!parsed.labels.length) return;

    const config = {
      chartBackground,
      chartLabel: chartLabel.length > 36 ? chartLabel.replace(/^(.{32}[^\s]*).*/, "$1") + " ..." : chartLabel,
      chartScore,
      chartCupper,
      labels: parsed.labels,
      values: parsed.values,
    };

    let chart;
    if (chartType === "radar") {
      chart = buildRadar(ctx, config);
    } else if (chartType === "polarArea") {
      chart = buildPolar(ctx, config);
    }

    if (chart) {
      charts.set(chartId, chart);
    }
  };

  const renderAll = () => {
    if (typeof Chart === "undefined") return;
    document.querySelectorAll(".forix-chartjs").forEach(renderOne);
  };

  const debounce = (fn, delay) => {
    let timer = null;
    return () => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(fn, delay);
    };
  };

  const scheduleRender = debounce(renderAll, 300);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderAll);
  } else {
    renderAll();
  }

  window.addEventListener("resize", scheduleRender);

  document.addEventListener("click", (event) => {
    const target = event.target.closest(".tab__list-item-opener, summary, details");
    if (target) {
      window.setTimeout(renderAll, 400);
    }
  });
})();
